import { useLanguage } from "@/contexts/LanguageContext";
import { Languages } from "lucide-react";
import { cn } from "@/lib/utils";

interface LanguageToggleProps {
    variant?: "desktop" | "mobile";
    className?: string;
}

const LanguageToggle = ({ variant = "desktop", className }: LanguageToggleProps) => {
    const { otherLang, switchLang } = useLanguage();
    const label = otherLang.toUpperCase();

    if (variant === "mobile") {
        return (
            <button
                type="button"
                onClick={() => switchLang(otherLang)}
                className={cn(
                    "w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white font-bold text-sm hover:bg-white/10 transition-colors",
                    className,
                )}
                aria-label={`Switch language to ${label}`}
            >
                <span className="inline-flex items-center gap-2">
                    <Languages size={16} />
                    {label}
                </span>
                <span className="text-xs font-black tracking-widest text-white/60">
                    {label === "EN" ? "English" : "العربية"}
                </span>
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={() => switchLang(otherLang)}
            className={cn(
                "inline-flex items-center gap-1.5 px-3 h-9 rounded-full bg-white/5 border border-white/10 text-white/80 hover:text-white hover:bg-white/10 transition-colors font-bold text-xs tracking-wider",
                className,
            )}
            aria-label={`Switch language to ${label}`}
        >
            <Languages size={14} />
            {label}
        </button>
    );
};

export default LanguageToggle;
